import * as React from 'react';

const At24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#ED2923", d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2H3z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M3 14h18v-4H3z" }), /* @__PURE__ */ React.createElement("path", { fill: "#ED2923", d: "M3 10h18V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z" }));
At24.Size = 24;
At24.Title = "At";

export { At24 as default };
